import React, { useMemo } from "react";
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from "@stripe/react-stripe-js";
import { getStripePromise } from "@/lib/stripe";

// Renders Stripe's embedded checkout on-site (no redirect).
// `onComplete` fires when the payment finishes.
export default function EmbeddedPayment({ clientSecret, onComplete }) {
  const stripePromise = useMemo(() => getStripePromise(), []);
  if (!clientSecret) return null;
  return (
    <div data-testid="embedded-checkout" className="bg-white">
      <EmbeddedCheckoutProvider stripe={stripePromise} options={{ clientSecret, onComplete }}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
}
